import { createContext } from 'react';

export const Context = createContext<{
  file: File | undefined;
  loading: boolean;
}>({
  file: undefined,
  loading: false,
});
